var VedioEvent = {}

// -- 个人录像记录
VedioEvent.UpdateMyselfVedioEvent = "VedioEvent.UpdateMyselfVedioEvent"

// -- 我收藏的录像记录
VedioEvent.UpdateCollectVedioEvent = "VedioEvent.UpdateCollectVedioEvent"

// -- 录像数据
VedioEvent.UpdatePublicVedioEvent = "VedioEvent.UpdatePublicVedioEvent"

// -- 取消收藏
VedioEvent.CancelCollectVedioEvent = "VedioEvent.CancelCollectVedioEvent"

// -- 收藏成功
VedioEvent.CollectSuccessVedioEvent = "VedioEvent.CollectSuccessVedioEvent"

// -- 刷新信息
VedioEvent.UpdateVedioDataEvent = "VedioEvent.UpdateVedioDataEvent"

// -- 今日点赞数量
VedioEvent.UpdateTodayLikeNum = "VedioEvent.UpdateTodayLikeNum"

// -- 打开\关闭个人收藏或个人记录
VedioEvent.OpenCollectViewEvent = "VedioEvent.OpenCollectViewEvent"

// --查看录像
VedioEvent.LOOK_VEDIO_EVENT = "VedioEvent.LOOK_VEDIO_EVENT"

// --点赞成功
VedioEvent.CLICK_Like_Vedio_EVENT = "VedioEvent.CLICK_Like_Vedio_EVENT"

module.exports = VedioEvent;